import { useState, useEffect, useMemo } from 'react'
import {
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Table as ChakraTable,
  Tbody,
  Td,
  Text,
  Tr,
  useDisclosure,
  Box,
  FormControl,
  FormLabel,
  Input,
  Select,
  Button,
  Heading,
  HStack,
  Stack,
  IconButton,
} from '@chakra-ui/react'
import { DatePicker } from 'antd'
import { search } from 'ss-search'
import moment from 'moment/moment'
import Table from 'components/Horizons/table'
import { FaFileExport } from 'react-icons/fa'
import axios from 'axios'
import { httpsCallable } from 'firebase/functions'
import { functions } from 'config/firebase'
import { useQuery } from 'react-query'
import { getKnowKids } from 'utils/kids'
// import { HiOutlineRefresh } from 'react-icons/hi'

const createFileExcelReportEveluation = httpsCallable(
  functions,
  'createReportEvaluation'
)

const getEvaluationReport = httpsCallable(functions, 'getEvaluationReport')

function ModalItems({ onClose, isOpen, data }) {
  const {
    kid,
    memberStatus,
    programs,
    evaluationPrograms,
    isMemberWaive,
    estimateName,
    statusAmount,
  } = data

  return (
    <Modal
      size='2xl'
      onClose={onClose}
      isOpen={isOpen}
      blockScrollOnMount={true}
    >
      <ModalOverlay />
      <ModalContent mx={4}>
        <ModalHeader fontWeight='normal'></ModalHeader>
        <ModalCloseButton />
        <ModalBody
          w='full'
          p={{ base: '5px', sm: '5px', md: '15px' }}
          maxH='80vh'
          overflowY='auto'
        >
          <Heading size='lg' textAlign='center'>{`${
            kid?.name ? kid?.name : ''
          } ${kid?.nickname ? `(${kid?.nickname})` : ''}`}</Heading>
          <Center
            p='0.5rem'
            w='full'
            border='1px solid #E2E8F0'
            overflowX='auto'
            mt={5}
          >
            <ChakraTable variant='simple' size='md'>
              <Tbody>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    วันเดือนปีเกิด
                  </Td>
                  <Td fontSize='lg'>
                    {kid?.birthday && kid?.birthday !== ''
                      ? moment(kid?.birthday, 'YYYY-MM-DD').format('DD/MM/YYYY')
                      : ''}
                  </Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    ผู้ปกครอง
                  </Td>
                  <Td fontSize='lg'>{kid?.parentName1}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    Telephone No.
                  </Td>
                  <Td fontSize='lg'>{kid?.parentTel1}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    Email Address
                  </Td>
                  <Td fontSize='lg'>{kid?.parentEmail1}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    ภาวะอาการ/Dx.
                  </Td>
                  <Td fontSize='lg'>{kid?.development?.diagnosis}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    แพทย์ที่ดูแล
                  </Td>
                  <Td fontSize='lg'>{kid?.development?.doctor}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    รู้จัก Kids Plus จาก
                  </Td>
                  <Td fontSize='lg'>
                    {getKnowKids({
                      kidKnow: kid?.know || {},
                      kidFrom: kid?.from || '',
                    })}
                  </Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    Enrollment
                  </Td>
                  <Td fontSize='lg'>
                    {programs?.length > 0 ? (
                      programs
                        .map(
                          (p) =>
                            `${p?.courseName} ${p?.choice} (${p?.amount} ${p?.unit})`
                        )
                        .join(', ')
                    ) : (
                      <span style={{ color: 'red' }}>Not Enroll</span>
                    )}
                  </Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    Programs Price
                  </Td>
                  <Td fontSize='lg'>
                    {programs?.length > 0 ? (
                      programs
                        .map((p) => `${p?.price?.toLocaleString()} บาท`)
                        .join(', ')
                    ) : (
                      <span style={{ color: 'red' }}>Not Enroll</span>
                    )}
                  </Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    Programs Paid
                  </Td>
                  <Td fontSize='lg'>
                    {programs?.length > 0 ? (
                      programs
                        .map((p) => {
                          const sumPaid =
                            (p?.payment?.transactions || [])
                              .filter(
                                (t) =>
                                  t?.action === 'paid' ||
                                  t?.action === 'prepaid'
                              )
                              ?.reduce?.((acc, pay) => acc + pay.paid, 0) || 0

                          return `${sumPaid.toLocaleString()} บาท`
                        })
                        .join(', ')
                    ) : (
                      <span style={{ color: 'red' }}>Not Enroll</span>
                    )}
                  </Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    Evaluation Enroll
                  </Td>
                  <Td fontSize='lg'>
                    {(evaluationPrograms || []).length > 0 ? (
                      evaluationPrograms
                        .map((p) => `${p?.courseName}`)
                        .join(', ')
                    ) : (
                      <span style={{ color: 'red' }}>Not Enroll</span>
                    )}
                  </Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    Evaluation Fee
                  </Td>
                  <Td fontSize='lg'>
                    {(evaluationPrograms || []).length > 0 ? (
                      (evaluationPrograms || [])
                        .map((p) => {
                          return p?.choice?.toLowerCase()?.includes('waive')
                            ? 'Evaluation Waive'
                            : `${p?.price?.toLocaleString()} บาท`
                        })
                        .join(', ')
                    ) : (
                      <span style={{ color: 'red' }}>Not Enroll</span>
                    )}
                  </Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    Member Apply
                  </Td>
                  <Td fontSize='lg'>
                    {`${
                      isMemberWaive
                        ? 'Member Waive'
                        : !memberStatus?.length
                        ? ''
                        : statusAmount > 0
                        ? Number(statusAmount).toLocaleString('th-TH') + ' บาท'
                        : ''
                    }`}
                  </Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    ผู้ประเมิน
                  </Td>
                  <Td fontSize='lg'>{`${
                    estimateName ? estimateName?.join(', ') : '-'
                  }`}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    สาขา
                  </Td>
                  <Td fontSize='lg'>{kid?.branch?.name || ''}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight={600} fontSize='lg'>
                    วันที่ประเมิน
                  </Td>
                  <Td fontSize='lg'>
                    {moment(data?.date, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                  </Td>
                </Tr>
              </Tbody>
            </ChakraTable>
          </Center>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export function Evalution({ data, branches, managerBranchId }) {
  const columnsData = [
    {
      Header: 'วันที่ประเมิน',
      accessor: 'date',
      width: '10%',
      extra: (_data, row) =>
        moment(row?.date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
    },
    {
      Header: 'ชื่อ-นามสกุล',
      accessor: 'kid.name',
      width: '10%',
    },
    {
      Header: 'ชื่อเล่น',
      accessor: 'kid.nickname',
      width: '10%',
    },
    {
      Header: 'Evaluation Fee',
      accessor: 'evaluationAmount',
      width: '10%',
      extra: (_evaluationAmount, row) => {
        if (row?.isEvaluationWaive) return 'Eva Waive'
        const evaluationFee = row?.evaluationAmount || 0
        return `${Number(evaluationFee).toLocaleString('th-TH')} บาท`
      },
    },
    {
      Header: 'Member Apply',
      width: '10%',
      accessor: 'memberApply',
      extra: (_memberApply, row) => {
        if (row?.isMemberWaive) return 'Member Waive'
        const upgradeStatus = row?.statusAmount || 0
        if (row?.memberStatus?.length === 0) return '-'
        return `${Number(upgradeStatus).toLocaleString('th-TH')} บาท`
      },
    },
    {
      Header: 'ยอดเงินจากการซื้อคอร์ส',
      accessor: 'enroll',
      width: '10%',
      extra: (_enroll, row) => {
        if (!row?.programs?.length) return '-'
        return `${Number(row?.paymentAmount || 0).toLocaleString('th-TH')} บาท`
      },
    },
    {
      Header: 'ผู้ประเมิน',
      accessor: 'staff',
      width: '10%',
      extra: (_enroll, row) => {
        if (row?.estimateName?.length === 0) return '-'
        return row?.estimateName?.join(', ')
      },
    },
    {
      Header: 'Action',
      accessor: 'kid',
      width: '10%',
      extra: (_data, row) => (
        <Button
          variant='link'
          textDecoration='underline'
          onClick={() => {
            setModalData(row)
            onOpen()
          }}
        >
          รายละเอียด
        </Button>
      ),
    },
  ]
  const [searchQuery, setSearch] = useState({
    text: '',
    branch: managerBranchId || '',
    month: moment().format('YYYY-MM'),
  })
  const [modalData, setModalData] = useState()
  const [downloadIsLoading, setDownloadIsLoading] = useState(false)

  const { onOpen, isOpen, onClose } = useDisclosure()

  const {
    data: reportEvaluation,
    isLoading,
    // refetch: refetchEvaluation,
    isRefetching,
  } = useQuery(
    ['evaluationReport', searchQuery?.month, searchQuery?.branch],
    async () => {
      const response = await getEvaluationReport({
        branchId: searchQuery?.branch,
        month: searchQuery?.month,
      })
      if (!response.data) {
        throw new Error('Network response was not ok')
      }
      return response.data
    },
    { refetchOnWindowFocus: false }
  )

  const [dataQuery, setDataQuery] = useState([])

  const sumEvaFee = useMemo(
    () => dataQuery?.summary?.totalEvaluationFee || 0,
    [dataQuery]
  )

  const sumMemberFee = useMemo(
    () => dataQuery?.summary?.totalMemberApply || 0,
    [dataQuery]
  )

  useEffect(() => {
    if (reportEvaluation) {
      setDataQuery(reportEvaluation)
    }
  }, [reportEvaluation])

  async function handleDownloadFile(dataDownload) {
    console.log('🚀 ~ handleDownloadFile ~ dataDownload:', dataDownload)
    setDownloadIsLoading(true)
    let rowCounter = 0
    const mapTime = dataDownload?.flatMap((d) => {
      const enrollmentPrograms =
        d?.programs?.length > 0
          ? d.programs
              .map(
                (p) => `${p?.courseName} ${p?.choice} (${p?.amount} ${p?.unit})`
              )
              .join(', ')
          : 'Not Enroll'

      const [filterEvaWaive, filterNormalEva] = [
        d?.evaluationPrograms.filter((p) =>
          p?.choice?.toLowerCase()?.includes('waive')
        ),
        d?.evaluationPrograms.filter(
          (p) => !p?.choice?.toLowerCase()?.includes('waive')
        ),
      ]

      const programsPaid =
        d?.programs?.length > 0
          ? d.programs
              .map((p) => {
                const sumPaid =
                  (p?.payment?.transactions || [])
                    .filter(
                      (t) => t?.action === 'paid' || t?.action === 'prepaid'
                    )
                    ?.reduce?.((acc, pay) => acc + pay.paid, 0) || 0
                return sumPaid
              })
              .reduce((acc, val) => acc + val, 0)
          : 0

      // expand 1 row per normal Eva program; fall back to 1 row if only waive/none
      const evaRows = filterNormalEva.length > 0 ? filterNormalEva : [null]

      return evaRows.map((eva, evaIndex) => {
        rowCounter++
        // ค่าระดับเด็ก (member apply, ยอดซื้อคอร์ส) ใส่เฉพาะ eva แถวแรก
        // ป้องกันยอดซ้ำเมื่อเด็กมี eva > 1 ครั้ง (split หลายแถว)
        const isFirstEvaRow = evaIndex === 0

        const evaFee =
          filterEvaWaive.length > 0 && filterNormalEva.length === 0
            ? 'Evaluation Waive'
            : eva
            ? Number(
                Number(
                  (eva?.payment?.transactions || [])
                    .filter((t) => t?.action === 'paid' && t?.paid > 0)
                    .reduce((acc, t) => acc + t.paid, 0)
                ).toFixed(2)
              )
            : 0

        const evaEnroll = eva
          ? `${eva?.courseName}`
          : filterEvaWaive.length > 0
          ? filterEvaWaive.map((p) => p?.courseName).join(', ')
          : 'Not Enroll'

        return {
          assessmentDate: moment(d.date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          number: rowCounter,
          kidName: d?.kid?.name ? d.kid.name : '',
          kidNickname: d?.kid?.nickname ? d.kid.nickname : '',
          birthday: d?.kid?.birthday
            ? moment(d?.kid?.birthday, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : '',
          parent: d?.kid?.parentName1 ? d?.kid?.parentName1 : '',
          telephone: d?.kid?.parentTel1 ? d?.kid?.parentTel1 : '',
          email: d?.kid?.parentEmail1 ? d?.kid?.parentEmail1 : '',
          developmentDiagnosis: d?.kid?.development?.diagnosis
            ? d?.kid?.development?.diagnosis
            : '',
          developmentDoctor: d?.kid?.development?.doctor
            ? d?.kid?.development?.doctor
            : '',
          knowKidsPlus: getKnowKids({
            kidKnow: d?.kid?.know || {},
            kidFrom: d?.kid?.from || '',
          }),
          evaluationEnroll: evaEnroll,
          evaluationFee: evaFee,
          enrollment: enrollmentPrograms,
          programsPrice:
            d?.programs?.length > 0
              ? d.programs.map((p) => `${p?.price?.toLocaleString()}`).join(', ')
              : 'Not Enroll',
          programsPaid:
            d?.programs?.length > 0
              ? `${programsPaid.toLocaleString()}`
              : 'Not Enroll',
          memberApply: !isFirstEvaRow
            ? ''
            : d?.isMemberWaive
            ? 'Member Waive'
            : !d?.memberStatus?.length
            ? ''
            : Number(Number(d?.statusAmount).toFixed(2)),
          branch: d?.kid?.branch?.name ? d?.kid?.branch?.name : '',
          assessor: eva?.staffNames || '-',
          entrollAmount: !isFirstEvaRow
            ? ''
            : d?.programs?.length === 0
            ? '-'
            : Number(d?.paymentAmount || 0),
        }
      })
    })

    createFileExcelReportEveluation(JSON.stringify(mapTime))
      .then(async (i) => {
        const url = i.data.fileUrl
        const fileName = i.data.fileName
        await axios({
          url,
          method: 'GET',
          responseType: 'blob',
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${fileName}`)
            document.body.appendChild(link)
            link.click()
          })
          .catch((err) => {
            console.error(err)
            setDownloadIsLoading(false)
          })
        setDownloadIsLoading(false)
      })
      .finally(() => {
        setDownloadIsLoading(false)
      })
  }

  function handleSearch(e) {
    e.preventDefault()
    setSearch({ ...searchQuery, text: e.target.value })
    let textSearch = e.target.value
    const searchQueryArr = reportEvaluation
    const searchKeys = ['kid.name', 'kid.nickname']
    const results = search(searchQueryArr, searchKeys, textSearch)
    const searchResults = textSearch === '' ? searchQueryArr : results
    setDataQuery(searchResults)
  }

  return (
    <Box>
      {isOpen && (
        <ModalItems isOpen={isOpen} onClose={onClose} data={modalData} />
      )}
      <Text color='brand'>Search</Text>

      <form onSubmit={handleSearch}>
        <Box
          borderWidth='1px'
          borderColor='brand'
          borderRadius='10px'
          p={5}
          mb={5}
          mt={1}
        >
          <HStack
            spacing={{ base: 0, md: '20px' }}
            flexDirection={{ base: 'column', sm: 'column', md: 'row' }}
          >
            <FormControl>
              <FormLabel>Search Name</FormLabel>
              <Input
                id='search'
                type='search'
                onChange={(e) => handleSearch(e)}
                value={searchQuery.text}
                placeholder='Search Name'
              />
            </FormControl>
            <FormControl>
              <FormLabel>Branch</FormLabel>
              <Select
                id='branch'
                placeholder='Pleas Select branch'
                onChange={(e) =>
                  setSearch({ ...searchQuery, branch: e.target.value })
                }
                value={searchQuery.branch}
                isDisabled={managerBranchId}
              >
                {branches
                  .sort(
                    (a, b) =>
                      b.accountType.localeCompare(a.accountType) ||
                      new Date(b.createdDate) - new Date(a.createdDate)
                  )
                  .map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name}
                    </option>
                  ))}
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>Month</FormLabel>
              <DatePicker
                allowClear={false}
                picker='month'
                format={'MMMM YYYY'}
                defaultValue={moment(searchQuery.month)}
                onChange={(date) =>
                  setSearch({
                    ...searchQuery,
                    month: moment(date).format('YYYY-MM'),
                  })
                }
              />
            </FormControl>
            <HStack alignSelf={'end'}>
              <IconButton
                variant='outline'
                fontSize={'23px'}
                icon={<FaFileExport color='#8CC63E' />}
                onClick={() => {
                  handleDownloadFile(dataQuery?.programs || [])
                }}
                disabled={
                  downloadIsLoading || !(dataQuery?.programs?.length > 0)
                }
                isLoading={downloadIsLoading}
              />
            </HStack>
            {/* <HStack alignSelf={'end'}>
              <IconButton
                variant='outline'
                fontSize={'23px'}
                icon={<HiOutlineRefresh color='#8CC63E' />}
                onClick={() => {
                  refetchEvaluation()
                }}
                disabled={isLoading || isRefetching}
                isLoading={isLoading || isRefetching}
              />
            </HStack> */}
          </HStack>
        </Box>
      </form>
      {searchQuery.branch !== '' ? (
        <>
          <Stack
            my={5}
            p={{ base: 2, md: 5 }}
            borderWidth='1px'
            borderColor='brand'
            borderRadius='10px'
            w={{ base: 'full', lg: '35vw' }}
          >
            <HStack justifyContent='space-between'>
              <Heading size={{ base: 'sm', md: 'md' }}>Total Eva Fee</Heading>
              <Heading size={{ base: 'sm', md: 'md' }}>{`${(
                sumEvaFee || 0
              )?.toLocaleString()} บาท`}</Heading>
            </HStack>
            <HStack justifyContent='space-between'>
              <Heading size={{ base: 'sm', md: 'md' }}>
                Total Member Apply
              </Heading>
              <Heading size={{ base: 'sm', md: 'md' }}>{`${(
                sumMemberFee || 0
              ).toLocaleString()} บาท`}</Heading>
            </HStack>
          </Stack>
          <Table
            columnsData={columnsData}
            tableData={dataQuery?.programs || []}
            noSearch
            loading={isLoading || isRefetching}
          />
        </>
      ) : (
        <Center>
          <Heading>Please Select Branch</Heading>
        </Center>
      )}
    </Box>
  )
}
